module.exports = __webpack_public_path__ + "img/pic2.d2e654fd.png";